import CombinedRevisionsModalContainer from 'ContentEditorUI/containers/CombinedRevisionsModalContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const PageThemeRevisionsModalContainer = () => {
  //@ts-expect-error - TODO: remove after CEUI PR with type is merged
  return /*#__PURE__*/_jsx(CombinedRevisionsModalContainer, {
    contentType: "page"
  });
};
export default PageThemeRevisionsModalContainer;